import Main from '@/components/main'

export default [{
    path: '/',
    redirect: {
        name: 'home'
    },
    meta: {
        hide: true,
        hideInMenu: true,
    },
    component: Main,
    children: [{
        path: 'home',
        meta: {
            title: "首页"
        },
        name: 'home',
        component: () =>
            import('_v/home/index')
    }]
}, {
    path: '/order-screen',
    name: 'orderScreen',
    meta: {
        hide: true,
        hideInMenu: true,
    },
    component: () =>
        import('_fv/order-screen/order-screen')
}]